<template>
  <div>
    <van-search
      v-model="value"
      :show-action="!!value"
      placeholder="请输入商品名称进行搜索"
      @search="onSearch"
      @cancel="onCancel"
    />

    <div class="c-fl-bt c-p-20 top">
      <div>搜索历史</div>
      <div class="delete-box c-fl">
        <g-img
          :src="deleteImg"
          :size="40"
          color="#999"
        ></g-img>
        <span>清空</span>
      </div>
    </div>

    <div class="list-box c-p-20">
      <div
        v-for="(v,i) in list"
        :key="i"
        class="list"
        @click="listHandler"
      >
        {{v.name}}
      </div>
    </div>

    <div class="c-fl-bt c-p-20 main">
      <div
        v-for="(v,i) in navList"
        :key="i"
        class="item"
        :class="activeIdx === i ? 'active' : ''"
        @click="handleNav(i)"
      >
        <div>{{v.name}}</div>
      </div>
    </div>
    <div class="not-found">
      <img
        :src="require('@/assets/images/not_found.png')"
        class="img"
        alt=""
        srcset=""
      >
      <div>
        <div>没有找到你想要的商品</div>
        <div>换个搜索词试试</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoodsSearch",
  props: {

  },
  data() {
    return {
      value: '',
      deleteImg: require('@/assets/images/clearCar.png'),
      activeIdx: 0,
      navList: [
        { name: '综合' },
        { name: '销量' },
        { name: '最新' },
        { name: '价格' },
      ],
      list: [
        { name: '盛世忌惮' },
        { name: '牛肉啥了' },
        { name: '三顿半速溶咖啡' },
        { name: '盛世忌惮' },
        { name: '牛肉啥了' },
        { name: '三顿半速溶咖啡' },
      ]
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    onSearch(val) {
      this.$toast(val);
    },
    onCancel() {
      this.$toast('取消');
    },
    listHandler() {
      this.$toast('列表点击');
    },
    handleNav(i) {
      this.activeIdx = i;
    }
  }
};
</script>
<style scoped lang='scss'>
.top {
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  margin: 10px 0;
  .delete-box {
    /* width: 140px; */
    span {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-left: 10px;
    }
  }
}
.list-box {
  display: flex;
  flex-wrap: wrap;
  .list {
    background: #f2f4f7;
    margin: 10px;
    padding: 10px 20px;
    border-radius: 32px;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}

::v-deep .van-search__action {
  font-size: 16px;
  font-family: PingFangHK-Semibold, PingFangHK;
  font-weight: 600;
  color: #ff9f00;
  /* line-height: 44px; */
}
.main {
  font-size: 32px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #8386a3;
  background: #ffffff;
  box-shadow: 0px 16px 20px 0px rgba(131, 134, 163, 0.12);
}
.not-found {
  width: 320px;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 30px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #cccccc;
  .img {
    width: 162px;
    margin: 0 0 20px 0;
  }
}
.active {
  color: var(--tc);
}
</style>
